<div
  class="search-container"
  [ngStyle]="{ height: onlyIds ? 'auto' : '50px' }"
  [class.panel-open]="auto.isOpen"
  #searchContainer>
  <mat-icon
    class="search-icon"
    svgIcon="search-icon"
    (click)="onSearch()"></mat-icon>

  <mat-form-field
    class="search"
    [ngStyle]="{ height: onlyIds ? 'auto' : '50px' }">
    <div matPrefix class="chips-container" *ngIf="idTags.length > 0 && onlyIds">
      <div
        class="filter-chip"
        *ngFor="let tag of idTags"
        [ngClass]="{ invalid: !tag.valid }">
        <p>{{ tag.id }}</p>
        <button
          mat-icon-button
          aria-label="Clear"
          [ngClass]="'close-button'"
          (mousedown)="
            removeIdTag(tag.id);
            $event.preventDefault();
            $event.stopPropagation()
          ">
          <mat-icon svgIcon="close-icon"></mat-icon>
        </button>
      </div>
    </div>
    <input
      matInput
      type="text"
      (keyup)="onKeyUp($event)"
      [placeholder]="isFocused ? '' : placeholder"
      [formControl]="searchControl"
      [matAutocomplete]="auto"
      (keypress)="onlyIds ? blockNonDigits($event) : null"
      (input)="onlyIds && sanitizeInput()"
      (focus)="onFocus()"
      (blur)="onBlur()"
      matAutocompletePosition="below"
      #searchInput />
    <mat-autocomplete #auto="matAutocomplete" [panelWidth]="getPanelWidth()">
      <div class="options-container item-search-autocomplete" *ngIf="!onlyIds">
        <ng-container *ngFor="let group of options">
          <mat-optgroup
            [label]="group.name"
            *ngIf="group.suggestions.length > 0">
            <mat-option
              *ngFor="let suggestion of group.suggestions"
              [value]="suggestion"
              (click)="onSuggestionClick(suggestion)">
              <div
                class="flex align-center gap-8px"
                *ngIf="group.name === 'Produkte'">
                <div class="image-container">
                  <img
                    [src]="suggestion.images[0].src"
                    alt="product image"
                    class="product-image" />
                </div>
                <p class="suggestion-name">
                  <span class="suggestion-brand">
                    {{ suggestion.brand.brandName }}
                  </span>
                  <span>{{ ' - ' }}</span>
                  <span>{{ suggestion.name }}</span>
                </p>
              </div>

              <div
                class="flex align-center gap-8px"
                *ngIf="group.name === 'Kategorien'">
                <div class="image-container">
                  <img
                    [src]="suggestion.iconUrl"
                    alt="category image"
                    class="product-image" />
                </div>

                <span
                  class="suggestion-name"
                  *ngIf="suggestion.type === 'category'">
                  {{ suggestion.name }}
                </span>

                <span
                  class="suggestion-name"
                  *ngIf="suggestion.type === 'subcategory'">
                  {{ suggestion.label }}
                </span>
              </div>
            </mat-option>
          </mat-optgroup>
        </ng-container>
      </div>
      <div class="options-container item-search-autocomplete" *ngIf="onlyIds">
        <ng-container>
          <mat-option
            *ngFor="let suggestion of options"
            [value]="suggestion"
            (click)="onSuggestionClick(suggestion)">
            <div class="flex align-center gap-8px">
              <div class="image-container">
                <img
                  [src]="suggestion.images[0].src"
                  alt="product image"
                  class="product-image" />
              </div>
              <p class="suggestion-name">
                <span class="suggestion-brand">
                  {{ suggestion.brand.brandName }}
                </span>
                <span>{{ ' - ' }}</span>
                <span>{{ suggestion.name }}</span>
              </p>
            </div>
          </mat-option>
        </ng-container>
      </div>
    </mat-autocomplete>
  </mat-form-field>
  <mat-icon
    svgIcon="close-icon"
    (click)="clearSearch()"
    *ngIf="searchControl.value.length > 0 && !onlyIds"></mat-icon>
</div>
